import React, { type JSX } from "react";
import { SupDrawer, SupButton, type DrawerProps } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

export interface MenuDrawerProps extends DrawerProps {
  contentClassName?: string;
  onClose?: () => void;
  actionButton?: JSX.Element;
}

export function MenuDrawer({ children, contentClassName, actionButton, onClose, ...allProps }: MenuDrawerProps) {
  const { className, ...props } = allProps;
  return (
    <SupDrawer {...props} className={twMerge("duration-300", className)}>
      <div className={twMerge("min-h-0 flex-1", contentClassName)}>{children}</div>
      <div className="flex shrink-0 flex-col gap-4 p-4">
        {actionButton}
        <SupButton fluid variant="outlined" color="primary" onClick={onClose}>
          Close
        </SupButton>
      </div>
    </SupDrawer>
  );
}
